const e = (...r) => r.filter((t) => t).join(" ").trim() || void 0;
export {
  e as classes
};
